module.exports = __webpack_public_path__ + "static/media/06-contact.1d6506e7.png";